import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var qs = require("querystring");

/**
 * Ottiene il conteggio dei lead non visti
 * @param {string} uname - Username
 * @param {string} token - Token di autenticazione
 * @returns {Promise<{success: boolean, count: number}>}
 */
export default async function getLeadsCount(uname, token) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "getLeadsCount.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        try {
          const resp = JSON.parse(body.toString());
          resolve(resp);
        } catch (e) {
          console.error("getLeadsCount parse error:", e);
          resolve({ success: false, count: 0 });
        }
      });

      res.on("error", function(error) {
        console.error(error);
        resolve({ success: false, count: 0 });
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
    });

    req.write(postData);
    req.end();
  });
}
